import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
// import { Message } from "element-ui";
import { message as Message } from "ant-design-vue";
import Cookie from "js-cookie";
import Store from "@/store/index";

const axiosInstance: AxiosInstance = axios.create();

axiosInstance.defaults.timeout = 20000;
// 添加一个请求拦截器（ 一般用于鉴权 )
axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const newConfig = { ...config };
    const TOKEN: string | undefined = Cookie.get("dock_web_token");
    if (TOKEN) newConfig.headers.Authorization = `Bearer ${TOKEN}`;
    return newConfig;
  },
  (error: any) => Promise.reject(error)
);
// 全局错误处理
const handleErrorRequest = (error: { response: SquareConfig }) => {
  const { response } = error;
  const status: number = response ? response.status : 408;

  if (response) {
    const { data } = response;
    const { errors } = data;
    const message: string = data.msg || data.message || "请求发送失败~";
    if (status === 401) {
      Store.dispatch("logout");
    } else if (status === 403) {
      Message.error("没有权限！");
    } else if (status === 419) {
      // 页面过期;
      localStorage.clear();
      sessionStorage.clear();
      Store.dispatch("logout");
    } else if (status === 422 || status === 423 || status === 429) {
      const errorObj: SquareConfig = errors ? errors : data;
      if (errorObj.msg) {
        return Message.error(errorObj.msg);
      }
      Object.keys(errorObj).forEach((errorKey) => {
        const errorValue: string = errorObj[errorKey].join("\n");
        Message.error(errorValue);
      });
    } else {
      Message.error(message);
    }
  } else {
    Message.error("网络超时");
  }
};
// 添加响应拦截器
axiosInstance.interceptors.response.use(
  (res: AxiosResponse<any>) => {
    switch (true) {
      case res.data.code === 200:
        return res.data.data;
      case res.data.error_code === 0:
        return res.data.data;
      case !!res.data.error_code:
        // Message.error({
        //   dangerouslyUseHTMLString: true,
        //   message: `<pre>${res.data.msg}</pre>`,
        // });
        Message.error(`${res.data.msg}`);
        return Promise.reject(res.data);
      default:
        return res.data;
    }
  },
  (error: any) => {
    handleErrorRequest(error);
    return Promise.reject(error);
  }
);

/* [请求库]
 ** @params url         { string }   @default => '' [接口地址，统一在global/resource文件中]
 ** @params data/params { object }   @default => {} [发送数据]
 ** @params config      { object }   配置
 */
export default {
  post(
    url: string = "",
    data: SquareConfig = {},
    config: SquareConfig = {}
  ): Promise<AxiosResponse<any>> {
    return axiosInstance.post(url, data, config);
  },
  put(
    url: string = "",
    data: SquareConfig = {},
    config: SquareConfig = {}
  ): Promise<AxiosResponse<any>> {
    return axiosInstance.put(url, data, config);
  },
  patch(
    url: string = "",
    data: SquareConfig = {},
    config: SquareConfig = {}
  ): Promise<AxiosResponse<any>> {
    return axiosInstance.patch(url, data, config);
  },
  get(
    url: string = "",
    params: SquareConfig = {},
    config: SquareConfig = {}
  ): Promise<AxiosResponse<any>> {
    const OPTIONS: SquareConfig = Object.assign({ params }, config);
    return axiosInstance.get(url, OPTIONS);
  },
  delete(
    url: string = "",
    params: SquareConfig = {},
    config: SquareConfig = {}
  ): Promise<AxiosResponse<any>> {
    const OPTIONS: SquareConfig = Object.assign({ params }, config);
    return axiosInstance.delete(url, OPTIONS);
  },
};
